/**
 * Base Templates Index
 *
 * Export all base templates for easy import
 * Templates follow SPARC methodology and Avezor patterns
 */

// Table Components
export { VirtualizedPropertyTable } from "./VirtualizedPropertyTable";
export type {
  VirtualizedPropertyTableProps,
  PropertyTableColumn,
} from "./VirtualizedPropertyTable";

export { BulkActionsPanel } from "./BulkActionsPanel";
export type { BulkActionsPanelProps } from "./BulkActionsPanel";

export { PropertyCheckbox } from "./PropertyCheckbox";
export type { PropertyCheckboxProps } from "./PropertyCheckbox";

export { SearchTablePage } from "./SearchTablePage";
export type { SearchTablePageProps, SearchFilter } from "./SearchTablePage";

// Re-export hook types
export type {
  BulkAction,
  BulkActionResult,
  UseBulkActionsOptions,
  UseBulkActionsReturn,
} from "@/hooks/useBulkActions";
export { useBulkActions } from "@/hooks/useBulkActions";
